import { Box, styled } from '@mui/material';

export const RegularCellContainer = styled(Box)(({ theme }) => ({
  width: '12%',
  padding: `${theme.spacing(1.25)} ${theme.spacing(1.5)}`,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderLeft: `2px solid ${theme.palette.primary.dark}`,
  position: 'relative',
}));

export const RegularCellBody = styled(Box)<{ isHovered: boolean }>(({ isHovered }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'center',
  opacity: isHovered ? 0.2 : 1,
}));

export const AvailabilityCellOptions = styled(Box)(({ theme }) => ({
  background: 'rgba(219, 237, 227, 0.7)',
  position: 'absolute',
  top: 0,
  left: 0,
  width: `calc(100% - ${theme.spacing(2)})`,
  height: `calc(100% - ${theme.spacing(2)})`,
  margin: `${theme.spacing(1)} 0px 0px ${theme.spacing(1)}`,
  borderRadius: '8px',
  zIndex: 1,
}));

export const AvailabilityCellActions = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
}));

export const AvailabilityBarContainer = styled(Box)(() => ({
  width: '100%',
  height: '25px',
  flexShrink: 0,
}));

export const AvailabilityBarBody = styled(Box)<{ isAvailable: boolean; isNotSubmitted: boolean; hasContract: boolean }>(
  ({ theme, isAvailable, isNotSubmitted, hasContract }) => ({
    width: '100%',
    height: '100%',
    border: (() => {
      if (hasContract && isNotSubmitted) {
        return 'none';
      }
      return `2px solid ${isAvailable ? theme.palette.primary.main : theme.palette.secondary.main}`;
    })(),
    borderRadius: '4px',
    display: isNotSubmitted && !hasContract ? 'none' : 'flex',
    flexShrink: 0,
    position: 'relative',
  }),
);

export const HasContractDot = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 'calc(50% - 8px)',
  left: '50%',
  transform: 'translateX(-50%)',
  minWidth: '20px',
  height: '16px',
  padding: `0 ${theme.spacing(0.5)}`,
  boxSizing: 'border-box',
  borderRadius: '8px',
  backgroundColor: '#FFC93C',
  color: theme.palette.secondary.contrastText,
  fontSize: '12px',
  fontWeight: 'bold',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const ContractHoverPanel = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.75),
  padding: theme.spacing(0.75),
  borderRadius: theme.spacing(1),
  backgroundColor: 'rgba(219, 237, 227, 0.7)',
  minWidth: '130px',
}));

export const ContractMiniCard = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette.info.main,
  border: '1px solid #FAFAFA',
  borderRadius: theme.spacing(1),
  padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
}));

export const ContractMiniCardHours = styled(Box)(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: '14px',
  lineHeight: '20px',
  color: theme.palette.primary.main,
}));

export const ContractMiniCardFunction = styled(Box)(({ theme }) => ({
  fontSize: '14px',
  lineHeight: '20px',
  color: theme.palette.secondary.main,
}));

export const AvailabilityBarSegment = styled(Box)<{ isAvailable: boolean }>(({ theme, isAvailable }) => ({
  width: '33.34%',
  height: '100%',
  backgroundColor: isAvailable && theme.palette.primary.main,
}));

export const RegularCellTextContainer = styled(Box)<{ isAvailable?: boolean }>(({ theme, isAvailable }) => ({
  fontWeight: 'bold',
  color: isAvailable ? theme.palette.secondary.contrastText : theme.palette.secondary.main,
  minHeight: '20px',
  flexShrink: 0,
  textAlign: 'center',
}));
